import React, {useEffect} from 'react';
import * as Routes from "../../routes/Routes"
import {Accordion, Card, Nav, Row} from "react-bootstrap";
import $ from 'jquery'
import UserRoleService, {
    HOME_MENU_PERMISSION_KEY,
    QUERIES_MENU_PERMISSION_KEY,
    REPORTS_MENU_PERMISSION_KEY,
    SSA_MENU_PERMISSION_KEY,
    TRADE_MENU_PERMISSION_KEY,
    TRADE_MENU_UPLOAD_PERMISSION_KEY,
    WIRES_MENU_CLIENT_APPROVER_PERMISSION_KEY,
    WIRES_MENU_VIEW_ONLY_PERMISSION_KEY, TRADE_MENU_BREAK_PERMISSION_KEY,
    ASSET_TRANSFER_SUBMITTER,ASSET_TRANSFER_INTERNAL_USER,ASSET_TRANSFER_VIEWONLY,
    WEB_ANNOUNCEMENTS_PERMISSION_KEY,
    CP_ADMIN_SCREEN
} from "service/UserRoleService";
import {SWIFT_MESSAGE_SEARCH, TRADECAPTURE_BREAKS} from "../../routes/Routes";
import {MenuDivider} from "./MenuDivider";

export default function TDAccordionNavBar(props) {
    useEffect(() => {
        /*Logic to rotate the arrow on expanding menu*/
        $('.nav-mobile-dropdown').on('click',function(){
            $(this).find('i').toggleClass('accordion-arrow-rotate')
        })
    },[]);
    const navigateToPage = props.navigateToPage;
    const hrForTab = <Row className={'d-none d-block d-md-none py-0 pl-2 ml-1'}><hr/></Row>;
    const hrForMob = <Row className={'d-none d-block d-md-none py-0 menu-divider-indent ml-1'}><hr/></Row>;

    const checkPermission = (menuKey) => {
        return UserRoleService.hasPermission(menuKey);
    }

    return (
        <>
            {checkPermission(HOME_MENU_PERMISSION_KEY) && (<Nav.Link className="tds-nav-item py-2" onClick={()=>{ navigateToPage(Routes.HOME);}}><b>Home</b></Nav.Link>)}
            {<MenuDivider className="pl-2" />}
            {(checkPermission(REPORTS_MENU_PERMISSION_KEY) || checkPermission(QUERIES_MENU_PERMISSION_KEY)) &&
            (<Accordion className={'py-0'}>
                <Card style={{border:'none'}}>

                    <Accordion.Toggle type='checkbox' id={'btnControl'} as={Card.Header} eventKey="0" className={'nav-mobile-dropdown'}>
                        Reporting <i className={'td-icon icon-small td-icon-downCaret accordion-arrow'} style={{position:'absolute',right:0}}/>
                    </Accordion.Toggle>

                    {checkPermission(REPORTS_MENU_PERMISSION_KEY) && (<Accordion.Collapse eventKey="0"  onClick={()=>{navigateToPage(Routes.REPORTS)}} >
                        <Card.Body className={'nav-mobile-dropdown nav-mobile-submenu'}>Reports</Card.Body>
                    </Accordion.Collapse>)}

                    {checkPermission(QUERIES_MENU_PERMISSION_KEY) && (<Accordion.Collapse eventKey="0"  onClick={()=>{navigateToPage(Routes.QUERIES)}} >
                        <Card.Body className={'nav-mobile-dropdown nav-mobile-submenu'}>Queries</Card.Body>
                    </Accordion.Collapse>)}
                </Card>
            </Accordion>)}


            {<MenuDivider className="pl-2" />}
            {(checkPermission(TRADE_MENU_PERMISSION_KEY) || checkPermission(TRADE_MENU_UPLOAD_PERMISSION_KEY)) &&
            (<Accordion className={'py-0'}>
                <Card style={{border:'none'}}>
                    <Accordion.Toggle as={Card.Header} eventKey="0" className={'nav-mobile-dropdown'}>
                        Trading <i className={'td-icon icon-small td-icon-downCaret accordion-arrow'} style={{position:'absolute',right:0}}/>
                    </Accordion.Toggle>
                    {checkPermission(TRADE_MENU_PERMISSION_KEY) && (
                    <Accordion.Collapse eventKey="0"  onClick={()=>{navigateToPage(Routes.TRADECAPTURE_LIST)}} >
                        <Card.Body className={'nav-mobile-dropdown nav-mobile-submenu'}>Trade List</Card.Body>
                    </Accordion.Collapse>)}
                    {checkPermission(TRADE_MENU_PERMISSION_KEY) && (
                    <Accordion.Collapse eventKey="0"  onClick={()=>{navigateToPage(Routes.TRADECAPTURE_ENTRY)}} >
                        <Card.Body className={'nav-mobile-dropdown nav-mobile-submenu'}>Trade Entry</Card.Body>
                    </Accordion.Collapse>)}
                    {checkPermission(TRADE_MENU_UPLOAD_PERMISSION_KEY) && (
                    <Accordion.Collapse eventKey="0"  onClick={()=>{navigateToPage(Routes.TRADECAPTURE_UPLOAD)}} >
                        <Card.Body className={'nav-mobile-dropdown nav-mobile-submenu'}>Trade Upload</Card.Body>
                    </Accordion.Collapse>)}
                    {checkPermission(TRADE_MENU_BREAK_PERMISSION_KEY) && (
                        <Accordion.Collapse eventKey="0"  onClick={()=>{navigateToPage(Routes.TRADECAPTURE_BREAKS)}} >
                            <Card.Body className={'nav-mobile-dropdown nav-mobile-submenu'}>Trade Breaks</Card.Body>
                        </Accordion.Collapse>)}

                </Card>
            </Accordion>)}


            {<MenuDivider className="pl-2" />}
            {(checkPermission(WIRES_MENU_CLIENT_APPROVER_PERMISSION_KEY)  || checkPermission(WIRES_MENU_VIEW_ONLY_PERMISSION_KEY)
               || checkPermission(ASSET_TRANSFER_SUBMITTER) || checkPermission(ASSET_TRANSFER_INTERNAL_USER) || checkPermission(ASSET_TRANSFER_VIEWONLY)
                  ) && (
            <Accordion className={'py-0'}>
                <Card style={{border:'none'}}>
                    <Accordion.Toggle as={Card.Header} eventKey="0" className={'nav-mobile-dropdown'}>
                        Asset Transfers <i className={'td-icon icon-small td-icon-downCaret'} style={{position:'absolute',right:0}}/>
                    </Accordion.Toggle>

                    {(checkPermission(WIRES_MENU_CLIENT_APPROVER_PERMISSION_KEY)  || checkPermission(WIRES_MENU_VIEW_ONLY_PERMISSION_KEY)
                         ) &&
                    <Accordion.Collapse eventKey="0"  onClick={()=>{navigateToPage(Routes.WIRES)}} >
                        <Card.Body className={'nav-mobile-dropdown nav-mobile-submenu'}>Wires</Card.Body>
                    </Accordion.Collapse>
                    }


                 {     (
                       checkPermission(ASSET_TRANSFER_SUBMITTER) || checkPermission(ASSET_TRANSFER_INTERNAL_USER) || checkPermission(ASSET_TRANSFER_VIEWONLY)
                       ) &&
                    <Accordion.Collapse eventKey="0"  onClick={()=>{navigateToPage(Routes.ASSET_TRANSFER_LIST)}} >
                        <Card.Body className={'nav-mobile-dropdown nav-mobile-submenu'}>Asset Transfer List</Card.Body>
                    </Accordion.Collapse>
                    }

                    { (  checkPermission(ASSET_TRANSFER_SUBMITTER) || checkPermission(ASSET_TRANSFER_INTERNAL_USER)
                       ) &&
                    <Accordion.Collapse eventKey="0"  onClick={()=>{navigateToPage(Routes.ASSET_TRANSFER_UPLOAD)}} >
                        <Card.Body className={'nav-mobile-dropdown nav-mobile-submenu'}>Assert Transfer Upload</Card.Body>
                    </Accordion.Collapse>
                    }

                    { (  checkPermission(ASSET_TRANSFER_SUBMITTER) || checkPermission(ASSET_TRANSFER_INTERNAL_USER)
                       ) &&

                    <Accordion.Collapse eventKey="0"  onClick={()=>{navigateToPage(Routes.ASSERTTRANSFER_ENTRY+'?from=menu')}} >
                        <Card.Body className={'nav-mobile-dropdown nav-mobile-submenu'}>Assert Transfer Entry</Card.Body>
                    </Accordion.Collapse>
                    }
                </Card>
            </Accordion>)}



            {<MenuDivider className="pl-2" />}
            {checkPermission(SSA_MENU_PERMISSION_KEY) && (
            <Accordion className={'py-0'}>
                <Card style={{border:'none'}}>
                    <Accordion.Toggle as={Card.Header} eventKey="0" className={'nav-mobile-dropdown'}>
                        Short Sale Approvals <i className={'td-icon icon-small td-icon-downCaret accordion-arrow'} style={{position:'absolute',right:0}}/>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="0"  onClick={()=>{navigateToPage(Routes.SHORTSALE_APPROVAL_LOCATE)}} >
                        <Card.Body className={'nav-mobile-dropdown nav-mobile-submenu'}>Locate</Card.Body>
                    </Accordion.Collapse>
                    <Accordion.Collapse eventKey="0"  onClick={()=>{navigateToPage(Routes.SHORTSALE_APPROVAL_HISTORY)}} >
                        <Card.Body className={'nav-mobile-dropdown nav-mobile-submenu'}>Persistent Locate</Card.Body>
                    </Accordion.Collapse>
                    <Accordion.Collapse eventKey="0"  onClick={()=>{navigateToPage(Routes.SHORTSALE_APPROVAL_SEARCH)}} >
                        <Card.Body className={'nav-mobile-dropdown nav-mobile-submenu'}>Search History</Card.Body>
                    </Accordion.Collapse>
                </Card>
            </Accordion>)}



            {<MenuDivider className="pl-2" />}
            <Accordion className={'py-0'}>
                <Card style={{border:'none'}}>
                    <Accordion.Toggle as={Card.Header} eventKey="0" className={'nav-mobile-dropdown'}>
                        Disclaimers <i className={'td-icon icon-small td-icon-downCaret'} style={{position:'absolute',right:0}}/>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="0"  onClick={()=>{navigateToPage(Routes.MMF)}} >
                        <Card.Body className={'nav-mobile-dropdown nav-mobile-submenu'}>MMF</Card.Body>
                    </Accordion.Collapse>
                </Card>
            </Accordion>

            {(checkPermission(CP_ADMIN_SCREEN)) && (
                <>
                    {<MenuDivider className="pl-2" />}
                    <Accordion className={'py-0'}>
                        <Card style={{border:'none'}}>
                            <Accordion.Toggle as={Card.Header} eventKey="0" className={'nav-mobile-dropdown'}>
                                Admin <i className={'td-icon icon-small td-icon-downCaret'} style={{position:'absolute',right:0}}/>
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="0"  onClick={()=>{navigateToPage(Routes.MNYWIRE)}} >
                                <Card.Body className={'nav-mobile-dropdown nav-mobile-submenu'}>Money Wires</Card.Body>
                            </Accordion.Collapse>
                            <Accordion.Collapse eventKey="0"  onClick={()=>{navigateToPage(Routes.WIRE_TEMPLATE)}} >
                                <Card.Body className={'nav-mobile-dropdown nav-mobile-submenu'}>Template</Card.Body>
                            </Accordion.Collapse>
                            <Accordion.Collapse eventKey="0"  onClick={()=>{navigateToPage(Routes.WIRE_TEMPLATE_UPLOAD)}} >
                                <Card.Body className={'nav-mobile-dropdown nav-mobile-submenu'}>Template Upload</Card.Body>
                            </Accordion.Collapse>
                            {checkPermission(WEB_ANNOUNCEMENTS_PERMISSION_KEY) &&
                            <Accordion.Collapse eventKey="0"  onClick={()=>{navigateToPage(Routes.WEB_ANNOUNCEMENTS)}} >
                                <Card.Body className={'nav-mobile-dropdown nav-mobile-submenu'}>Web Announcements</Card.Body>
                            </Accordion.Collapse>}
                        </Card>
                        {<MenuDivider className="menu-divider-indent" />}
                        <Card style={{border:'none'}}>
                            <Accordion.Collapse eventKey="0"  onClick={()=>{navigateToPage(Routes.SWIFT_WIRES_LIST)}} >
                                <Card.Body className={'nav-mobile-dropdown nav-mobile-submenu'}>Swift Wires</Card.Body>
                            </Accordion.Collapse>
                            <Accordion.Collapse eventKey="0"  onClick={()=>{navigateToPage(Routes.SWIFT_MESSAGE_SEARCH)}} >
                                <Card.Body className={'nav-mobile-dropdown nav-mobile-submenu'}>Swift Messages</Card.Body>
                            </Accordion.Collapse>
                            <Accordion.Collapse eventKey="0"  onClick={()=>{navigateToPage(Routes.SWIFT_TRANSACTIONS)}} >
                                <Card.Body className={'nav-mobile-dropdown nav-mobile-submenu'}>Swift Transaction</Card.Body>
                            </Accordion.Collapse>

                        </Card>
                        {<MenuDivider className="menu-divider-indent" />}
                        <Card style={{border:'none'}}>
                            <Accordion.Collapse eventKey="0"  onClick={()=>{navigateToPage(Routes.CLEARING_SYSTEM)}} >
                                <Card.Body className={'nav-mobile-dropdown nav-mobile-submenu'}>Clearing System</Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                </>
            )}
            {hrForTab}


        </>)
}